import * as React from 'react';
import { style } from 'typestyle';
import { vertical, center, startJustified } from 'csstips';
import { TrackTile } from '../track-tile';
import { percent, px, viewWidth } from 'csx';
import { colorBrand } from '../../theme/color';
import { mediaTablet, mediaMobileOnly } from '../../theme/media';
import { Carousel } from '../carousel';
import { observer } from 'mobx-react';
import { PlaylistGroupPlaylistSchema, TrackSchema } from '../../types/schema';
import { ImagePreloader } from '../../types/fn';
import { AnalyticsController } from '../../modules/analytics/controller';
import PlaylistTile from './playlist-tile';
import { Component, deps, inject } from '../../lib/component';

export interface PlaylistCarouselProps {
  playlists: PlaylistGroupPlaylistSchema[];
  onClickLink(event: React.MouseEvent<any>): void;
}

const DEFAULT_I18N = {
  availableFor: 'Available for',
};

const constants = {
  mobileSize: viewWidth(75),
  desktopSize: viewWidth(20),
  availabilitySize: px(50),
};

@observer
export class PlaylistCarousel extends React.Component<PlaylistCarouselProps> {
  render() {
    const { playlists, onClickLink } = this.props;

    return (
      <Carousel
        // className={PlaylistCarousel.styles.carousel}
        innerClassName={PlaylistCarousel.styles.carouselInner}
        spacerClassName={PlaylistCarousel.styles.carouselSpacer}
        scrollerClassName={PlaylistCarousel.styles.carouselScroller}
      >
        {playlists.map(({ name, slug, uuid, track_images }, index) => (
          <div key={index} className={PlaylistCarousel.styles.trackContainer}>
            <PlaylistTile title={name} slug={slug} identity={uuid} images={track_images} onClickLink={onClickLink} />
          </div>
        ))}
      </Carousel>
    );
  }

  static styles = {
    carouselInner: style(
      {
        scrollbarWidth: 'none',
        $nest: {
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        },
      },
      mediaMobileOnly({ padding: '0 20px' }),
      mediaTablet({ padding: '0 40px' }),
    ),
    carouselSpacer: style({ flexShrink: 0 }, mediaMobileOnly({ width: px(20) }), mediaTablet({ width: px(40) })),
    carouselScroller: style({
      backgroundImage: 'none',
      $nest: {
        '& [role="button"]': {
          width: px(32),
          height: px(32),
          $nest: {
            '& > svg': {
              width: px(10),
              height: px(10),
            },
          },
        },
      },
    }),
    trackContainer: style({
      ...vertical,
      ...center,
      ...startJustified,
      position: 'relative',
      height: 'auto !important',
      flexShrink: 0,
      flexBasis: 'auto',
    }),
    track: style({
      height: 'auto !important',
      width: percent(100),
    }),
    availability: style({
      height: constants.availabilitySize,
      lineHeight: constants.availabilitySize,
      fontWeight: 'bold',
      $nest: { '&> span': { color: colorBrand.toString() } },
    }),
  };
}
